<template>
    <el-card class="industry">
        <div slot="header" class="clearfix">
            <span>留言行业排行</span>
        </div>
        <data-list :data="chartConf.data.rows" :columns="column" :loading="loading"></data-list>
    </el-card>
</template>

<script>
    import mixin from './mixin'
    import api from '@/backend/apiConfig/apiConfig'
    export default {
        name: "enquiryIndustry",
        mixins: [mixin],
        data() {
            return {
                loading: false,
                column: [{
                    label: '行业',
                    bind: 'name'
                }, {
                    label: '询盘数',
                    bind: 'num'
                }, {
                    label: '占比',
                    bind: 'percentageStr'
                }]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .industry {
        height: 100%;
    }
</style>
